var $class="se2--application-social-media-share-horizontal",$name="ApplicationSocialMediaShareHorizontal",$path="app/components/ApplicationSocialMediaShareHorizontal/index.js",$this={$class,$name,$path,};import shell from 'app/modules/shell';

import forEach from 'lodash/forEach';
import esapi from 'node-esapi';

import { placeholderInUrl, socialLinkSelector, printButtonSelector } from './config';

export default shell.registerComponent($this, ({ addEventListener, mount }) => {
  mount((element) => {
    forEach(
      element.querySelectorAll(printButtonSelector),
      (printButton) => {
        addEventListener(printButton, 'click', () => window.print());
      },
    );

    const { origin, pathname, search } = window.location;
    let currentURL = origin + pathname;

    if (search) currentURL += esapi.encoder().encodeForURL(search);

    forEach(
      element.querySelectorAll(socialLinkSelector),
      (link) => {
        link.href = link.href.replace(placeholderInUrl, currentURL);
      },
    );
  });
});
